// extracted by mini-css-extract-plugin
export var container = "_et-0";
export var icon = "_et-1";
export var text = "_et-2";